import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { Button } from '../components/primitives';
import './NotFound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <SEO title={t('notFound.title', 'Page Not Found')} />
      <div className="not-found-content">
        <div className="not-found-numeral" aria-hidden="true">404</div>
        <h1 className="not-found-title">
          {t('notFound.title', 'Page Not Found')}
        </h1>
        <p className="not-found-message">
          {t('notFound.message', "The page you're looking for doesn't exist or has been moved.")}
        </p>
        <div className="not-found-actions">
          <Button as="link" to="/" variant="brand" size="md">
            {t('notFound.goHome', 'Go Home')}
          </Button>
          <Button as="link" to="/products" variant="secondary" size="md">
            {t('notFound.browseProducts', 'Browse Products')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
